import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import styles from './index.css';
import { isGrounds } from '@src/utils/app';
import { getThumbnail, formatImage, gotoNewPage } from '@src/utils';
import { getDispatchAction } from '@src/utils/url';

Swiper.use([Navigation, Pagination]);

const MainSwiper = (props) => {
    const { content } = props;

    useEffect(() => {
        new Swiper('#swiper1', {
            modules: [Autoplay],
            autoplay: true,
            speed: 1500,
            loop: true,
            pagination: {
                el: '#pagination1',
                renderBullet(index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
        });
    }, []);

    const gotoDetail = (item) => {
        return () => {
            const { url, type, base62Id } = item;
            const jumpUrl = getDispatchAction(url, type, base62Id, isGrounds);

            gotoNewPage({ type: jumpUrl[0], url: jumpUrl[1] })();
        };
    };

    return (
        <div className={styles.swiperWp}>
            <div className={`${styles.swiper1} swiper`} id="swiper1">
                <div className="swiper-wrapper">
                    {content.map((item, index) => {
                        return (
                            <div className="swiper-slide" key={index} onClick={gotoDetail(item)}>
                                <div className={styles.swiperItem}>
                                    <img className={styles.swiperImage} src={formatImage(getThumbnail(item), 182 * 2, 150 * 2)} alt={item.title} />
                                    <div className={styles.content}>
                                        <div className={styles.title}>{item.title}</div>
                                        <div className={styles.summary}>
                                            <span className={styles.tag}>{item.source}：</span>
                                            <span>{item.summary}</span>
                                        </div>
                                        <div className={styles.btnbox}>
                                            <div className={styles.btn}>阅读</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={styles.pagination1} id="pagination1" />
        </div>
    );
};

MainSwiper.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(MainSwiper);
